var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCasetteVhs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 432C0 458.508 21.49 480 48 480H528C554.51 480 576 458.508 576 432V160H0V432ZM416 349C435.125 342.375 448 324.25 448 304S435.125 265.625 416 259V224H464.875C484 245.25 496 273.125 496 304S484 362.75 464.875 384H416V349ZM224 224H352V384H224V224ZM111.125 224H160V259C140.875 265.625 128 283.75 128 304S140.875 342.375 160 349V384H111.125C92 362.75 80 334.875 80 304S92 245.25 111.125 224ZM528 32H48C21.49 32 0 53.492 0 80V128H576V80C576 53.492 554.51 32 528 32Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCasetteVhs);
export default __webpack_public_path__ + "static/media/casette-vhs.49c3241e580e7e2c9b10506d479c6673.svg";
export { ForwardRef as ReactComponent };